(() => {
  const setupAuthorsScroller = (scroller) => {
    if (!scroller || scroller.dataset.authorsScrollReady === 'true') return;
    scroller.dataset.authorsScrollReady = 'true';

    let isPointerDown = false;
    let isDragging = false;
    let suppressClick = false;
    let startY = 0;
    let startScrollTop = 0;
    const DRAG_THRESHOLD = 6;

    scroller.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary) return;
      isPointerDown = true;
      isDragging = false;
      startY = event.clientY;
      startScrollTop = scroller.scrollTop;
    });

    scroller.addEventListener('pointermove', (event) => {
      if (!isPointerDown) return;
      const delta = event.clientY - startY;

      if (!isDragging && Math.abs(delta) < DRAG_THRESHOLD) return;

      if (!isDragging) {
        isDragging = true;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);
      }

      scroller.scrollTop = startScrollTop - delta;
    });

    const stopDragging = (event) => {
      if (!isPointerDown) return;
      suppressClick = isDragging;
      isPointerDown = false;
      isDragging = false;
      scroller.classList.remove('is-dragging');
      if (event.pointerId != null && scroller.hasPointerCapture(event.pointerId)) {
        scroller.releasePointerCapture(event.pointerId);
      }
    };

    scroller.addEventListener('pointerup', stopDragging);
    scroller.addEventListener('pointercancel', stopDragging);
    scroller.addEventListener('pointerleave', stopDragging);

    scroller.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-authors-scroll]').forEach(setupAuthorsScroller);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
